export default "__VITE_ASSET__fb19a199__"